<app-dialog-header label="{{this.fileName }}" i18n-label></app-dialog-header>
<div class="text-center">
  <img [attr.src]= this.imageData class="img-fluid"  style="vertical-align: middle;" />
</div>
